import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import { Text, TextSize, TextWeight } from './textStyles'
import { Link, To } from 'react-router-dom'
import { BaseButton } from '../../components'
import { contentColorStyle } from '../buttons/button'

type LinkType = 'default' | 'authentication' | 'footer'

const typeStyles = {
    default: css`
        color: ${(p) => p.theme.colors.blue.link};
    `,
    authentication: css`
        color: ${(p) => p.theme.colors.blue.link};
    `,
    footer: css``,
}

const Label = styled(Text)<{ type: LinkType; $disabled?: boolean }>`
    text-decoration: underline;
    color: ${(p) => p.theme.colors.tertiary.tertiary900};

    ${(props) => typeStyles[props.type]}

    ${(p) =>
        p.$disabled && contentColorStyle(p.theme.colors.tertiary.tertiary600)}
`

const Button = styled(BaseButton)`
    justify-content: left;

    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
    }
`

interface Props {
    type: LinkType
    to?: To
    onClick?: () => void
    text: string
    className?: string
    disabled?: boolean
}

export const LinkText: FC<Props> = ({
    type,
    text,
    to,
    onClick,
    disabled,
    ...props
}) => {
    const textSize = (): TextSize => {
        switch (type) {
            case 'default':
                return 'xSmall'
            case 'authentication':
                return 'medium'
            case 'footer':
                return 'small'
        }
    }

    const textWeight = (): TextWeight => {
        switch (type) {
            case 'default':
                return 'regular'
            case 'authentication':
                return 'medium'
            case 'footer':
                return 'regular'
        }
    }

    return (
        <>
            {to && (
                <Link to={to} type={type} {...props}>
                    <Label
                        size={textSize()}
                        $weight={textWeight()}
                        color="none"
                        type={type}
                    >
                        {text}
                    </Label>
                </Link>
            )}
            {onClick && (
                <Button onClick={onClick} disabled={disabled}>
                    <Label
                        size={textSize()}
                        $weight={textWeight()}
                        color="none"
                        type={type}
                        $disabled={disabled}
                        {...props}
                    >
                        {text}
                    </Label>
                </Button>
            )}
        </>
    )
}
